import { APP_FLAVOR_ORGAN } from "./appFlavor";

const MANIFEST_FILES = {
    user: "manifest-user.json",
    organ: "manifest-organ.json",
};

const THEME_COLORS = {
    user: "#2E71FC",
    organ: "#173d8f",
};

export const getManifestHref = (flavor, publicUrl = "") => {
    const base = String(publicUrl || "").replace(/\/$/, "");
    const file = MANIFEST_FILES[flavor] || MANIFEST_FILES.user;
    return `${base}/${file}`;
};

export const applyWebManifest = (flavor, documentRef = document) => {
    if (!documentRef) return;
    const publicUrl = process.env.PUBLIC_URL || "";
    const href = getManifestHref(flavor, publicUrl);
    const link = documentRef.querySelector('link[rel="manifest"]');
    if (link && link.getAttribute("href") !== href) {
        link.setAttribute("href", href);
    }
    const theme = THEME_COLORS[flavor] || THEME_COLORS.user;
    const themeMeta = documentRef.querySelector('meta[name="theme-color"]');
    if (themeMeta) {
        themeMeta.setAttribute("content", theme);
    }
    const titleMeta = documentRef.querySelector(
        'meta[name="apple-mobile-web-app-title"]'
    );
    if (titleMeta) {
        titleMeta.setAttribute(
            "content",
            flavor === APP_FLAVOR_ORGAN ? "فیدیما سازمان" : "فیدیما"
        );
    }
};
